import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { hubAccessLevels } from '../../constant/config';
import { dateCompare } from '../../lib/utilities';
import Section from './Section';
import './HomeTab.css';
import CarouselSection from './CarouselSection';

class HomeTab extends Component {
  getNoModuleContent() {
    if (this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      return (
        <div className="no-modules">
          <div className="no-module-text">
            This hub does not have any folders yet, to get started create your
            first folder in the Create tab above.
          </div>
          {/* <Button
            className="create-module-button"
            onClick={() => this.props.changeTab(5)}
          >
            Create Folder
          </Button> */}
        </div>
      );
    }
    return (
      <div className="no-modules">
        {this.props.user
          ? 'It looks like the hub admins have not added any folders yet. Please check back later.'
          : 'It looks like the hub admins have not added any public folders yet. Please check back later.'}
      </div>
    );
  }
  onMakeFeaturedClick() {
    this.props.changeToSettingsTab();
  }
  getNoFeaturedFolder() {
    return (
      <div className="no-modules">
        <div className="no-module-text">
          <h3 className="section-title">
            <div>Featured Folders</div>
            <span>
              <Button
                className="select-featured-button"
                onClick={() => this.onMakeFeaturedClick()}
              >
                Select Featured Folders →
              </Button>
            </span>
          </h3>

          <div className="sub-title">
            There are no featured folders selected
          </div>
          <div className="description">
            Featuring will let your users know about the content your hub has at
            a glance. You can choose to set featured folders from Hubs >
            Settings > Featured Folders, or click on the ‘Select Featured
            Folders’ button above.
          </div>
        </div>
      </div>
    );
  }
  render() {
    const plansFiltered = this.props.plans.sort(dateCompare);
    const foldersFeatured = this.props.featuredFolders;

    let infoHeaderFolder;
    let infoTextFolder;
    if (this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      infoHeaderFolder = 'What are Featured Folders?';
      infoTextFolder =
        'Featuring will let your users know about the content your hub has at a glance. You can choose to set eight featured folders from Hubs > Settings > Featured Folders.';
    }
    return (
      <div className="home-tab-container">
        {!foldersFeatured.length > 0 &&
          this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN && (
            <div className="featured-modules">
              {' '}
              {this.getNoFeaturedFolder()}
            </div>
          )}
        {foldersFeatured.length > 0 && (
          <div className="featured-modules">
            <CarouselSection
              noExpand
              context="plans"
              title="Featured Folders"
              tiles={foldersFeatured}
              hub={this.props.hub}
              infinite={true}
              infoHeader={infoHeaderFolder}
              infoText={infoTextFolder}
            />
          </div>
        )}
        <hr className="hr-line"></hr>
        {!this.props.plans.length > 0 && this.getNoModuleContent()}
        {plansFiltered.length > 0 && (
          <Section
            context="plans"
            title="All Folders"
            tiles={plansFiltered}
            small={true}
            hub={this.props.hub}
          />
        )}
      </div>
    );
  }
}

export default HomeTab;
